module.exports = __webpack_public_path__ + "static/media/icon-time-period.5b15b019.svg";